<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>
<ion-content>
  <ion-list
    mode="ios"
    [inset]="true"
    lines="none"
    *ngIf="!showAddressInput"
    class="ion-no-margin"
  >
    <div
      class="d-flex ion-align-items-center ion-no-padding ion-no-margin ion-margin"
    >
      <dynamic-address-input
        #dynamicAddressInput
        class="address-input"
        (setAddress)="getAddress($event)"
        adressType="geocode"
      ></dynamic-address-input>
      <ion-button
        class="primary-btn locate-icon-button"
        (click)="showMapWithCurrentLocation()"
      >
        <ion-icon
          name="locate-outline"
          class="ion-no-padding ion-no-margin locate-icon white-icon-color"
        ></ion-icon>
      </ion-button>
    </div>
  </ion-list>
  <div class="map-container" *ngIf="!showAddressInput">
    <capacitor-google-map #map></capacitor-google-map>
    <ion-img
      *ngIf="showMarker"
      src="/assets/icons/marker.svg"
      style="
        position: absolute;
        top: calc(50% - 20px);
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
        width: 40px;
      "
    ></ion-img>
  </div>
  <div *ngIf="showAddressInput">
    <form [formGroup]="AddressForm">
      <ion-list class="marb-0">
        <ion-item>
          <ion-label position="stacked" for="street">{{"modals.address_selector_modal.street" | translate}}</ion-label>
          <ion-input
            type="text"
            placeholder="Enter Street"
            id="street"
            formControlName="street"
          ></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked" for="line2">{{"modals.address_selector_modal.locality" | translate}}</ion-label>
          <ion-input
            type="text"
            id="line2"
            placeholder="Enter Locality"
            formControlName="line2"
          ></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked" for="landmark">{{"modals.address_selector_modal.landmark" | translate}}</ion-label>
          <ion-input
            type="text"
            id="landmark"
            placeholder="Near Orion Mall"
            formControlName="landmark"
          ></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked" for="city_name">{{"modals.address_selector_modal.city" | translate}}</ion-label>
          <ion-input
            type="text"
            id="city_name"
            placeholder="Enter City Name"
            formControlName="city_name"
          ></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked" for="postal_code">{{"modals.address_selector_modal.pincode" | translate}}</ion-label>
          <ion-input
            type="text"
            id="postal_code"
            placeholder="Enter Postal Code"
            formControlName="postal_code"
          ></ion-input>
        </ion-item>
      </ion-list>
      <ion-button
        (click)="saveAddress()"
        color="primary"
        fill="solid"
        expand="block"
        shape="round"
        class="ion-margin mart-20"
      >
      {{"modals.address_selector_modal.save_address" | translate}}
      </ion-button>
    </form>
  </div>
</ion-content>
<ion-footer *ngIf="showMarker && !showAddressInput">
  <ion-toolbar class="padt-10">
    <ion-label class="ion-text-center">
      <h4>
        {{
          structuredAddress?.formatted_address 
            ? structuredAddress.formatted_address 
            : ("modals.address_selector_modal.please_select_a_valid_location" | translate)
        }}
      </h4>
      
      <!-- <h4>{{ structuredAddress?.line2 }}</h4>
      <p>{{ structuredAddress?.street }}</p> -->
    </ion-label>
  </ion-toolbar>
  <ion-toolbar class="ion-padding-horizontal padt-5 padb-10">
    <ion-button
      class="primary-btn"
      fill="solid"
      expand="block"
      (click)="saveAddress()"
      [disabled]="!structuredAddress?.formatted_address"
    >
    {{"modals.address_selector_modal.confirm" | translate}}
    </ion-button>
  </ion-toolbar>
</ion-footer>
<!-- street line2 landmark city_name postal_code -->
